import React from 'react';

import { useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import InformationIcon from '@atlaskit/icon/core/status-information';
import { Anchor } from '@atlaskit/primitives/compiled/anchor';
import { Text } from '@atlaskit/primitives/compiled/text';
import { token } from '@atlaskit/tokens';

import { messages } from './messages';

const styles = cssMap({
	anchor: {
		display: 'flex',
		alignItems: 'center',
		gap: token('space.050'),
		textDecoration: 'none',
		'&:visited': {
			textDecoration: 'none',
		},
		'&:hover': {
			textDecoration: 'none',
		},
	},
});

export const CardsAIDisclaimer: React.FC = () => {
	const { formatMessage } = useIntl();

	const disclaimerMessage = formatMessage(messages.disclaimerMessage);

	return (
		<Anchor
			href="https://www.atlassian.com/trust/atlassian-intelligence"
			xcss={styles.anchor}
			target="_blank"
		>
			<InformationIcon label="" color={token('color.icon.subtle')} size="small" />
			<Text size="small" color="color.text.subtlest">
				{disclaimerMessage}
			</Text>
		</Anchor>
	);
};
